import React from "react"
export default function NavBar(props) {
  return (
    <div>
      <nav className="navbar navbar-fixed-top navbar-dark bg-dark">
        <a className="navbar-brand" href="/">
          MonkCode
        </a>
        <ul className="navbar-nav">
          <li>
            <a className="nav-link" href="https://github.com/SamMonk">
              GitHub
            </a>
          </li>
        </ul>
        <ul className="navbar-nav">
          <li>
            <a className="nav-link" href="/sitemap.xml">
              Sitemap
            </a>
          </li>
        </ul>
      </nav>
    </div>
  )
}
